/* ============================================================
   Asma Theme — original theme scripts (vanilla JS, no deps)
   ============================================================ */
(function () {
  'use strict';

  var d = document;

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('[data-animate]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var groups = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var group = el.closest('[data-animate-group]');
        var delay = 0;
        if (group) {
          var count = groups.get(group) || 0;
          delay = Math.min(count * 90, 540);
          groups.set(group, count + 1);
          setTimeout(function () { groups.set(group, Math.max(0, (groups.get(group) || 1) - 1)); }, 900);
        }
        setTimeout(function () { el.classList.add('is-revealed'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky header (hide on scroll down, show on up) ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header || !header.classList.contains('site-header--sticky')) return;
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        header.classList.toggle('is-stuck', y > 10);
        if (y > 250 && y > lastY + 6) header.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 250) header.classList.remove('is-hidden');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    var wrap = $('[data-announcement-rotator]');
    if (!wrap) return;
    var msgs = $$('.announcement-bar__message', wrap);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      msgs[i].style.position = 'absolute';
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
      msgs[i].style.position = 'relative';
    }, 5000);
  }

  /* ---------- Localization auto-submit ---------- */
  function initLocalization() {
    $$('[data-localization-submit]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.closest('form').submit(); });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    function open() { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden'; }
    function close() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; }
    $$('[data-mobile-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mobile-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
  }

  /* ---------- Search bar ---------- */
  function initSearch() {
    var bar = $('[data-search-bar]');
    if (!bar) return;
    var input = $('[data-search-input]', bar);
    var results = $('[data-search-results]', bar);
    var timer;

    $$('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        bar.hidden = !bar.hidden;
        if (!bar.hidden && input) input.focus();
      });
    });
    $$('[data-search-close]').forEach(function (b) {
      b.addEventListener('click', function () { bar.hidden = true; });
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') bar.hidden = true; });

    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              results.innerHTML = products.map(function (p) {
                return '<a class="search-result-card" href="' + p.url + '">' +
                  (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=200" alt="" loading="lazy" style="margin-bottom:10px">' : '') +
                  '<span class="search-result-card__title">' + p.title + '</span>' +
                  '<span>' + (p.price ? formatMoney(parseFloat(p.price) * 100) : '') + '</span></a>';
              }).join('');
            })
            .catch(function () {});
        }, 300);
      });
    }
  }

  /* ---------- Slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (slider) {
      var slides = $$('[data-slide]', slider);
      if (slides.length < 2) return;
      // Preload all slide images so rotation never shows a blank frame
      $$('img', slider).forEach(function (img) { img.loading = 'eager'; });
      var dots = $$('[data-slide-dot]', slider);
      var current = 0;
      var timer = null;
      var interval = parseInt(slider.dataset.interval, 10) || 6000;

      function goTo(i) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }
      function start() {
        if (slider.dataset.autoplay !== 'true') return;
        stop();
        timer = setInterval(function () { goTo(current + 1); }, interval);
      }
      function stop() { if (timer) clearInterval(timer); }

      var prev = $('[data-slide-prev]', slider);
      var next = $('[data-slide-next]', slider);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); start(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.slideDot, 10)); start(); });
      });

      var startX = null;
      slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) goTo(dx > 0 ? current - 1 : current + 1);
        startX = null;
      }, { passive: true });

      start();
    });
  }

  /* ---------- Cart API ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 300);
    });
  }

  function rerenderDrawer() {
    var body = $('[data-cart-body]');
    if (!body) return Promise.resolve();
    body.classList.add('is-loading');
    return fetch(window.location.pathname + '?section_id=cart-drawer-section')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-cart-body]', tmp);
        if (fresh) body.innerHTML = fresh.innerHTML;
        var label = $('[data-cart-count-label]');
        var freshLabel = $('[data-cart-count-label]', tmp);
        if (label && freshLabel) label.textContent = freshLabel.textContent;
        body.classList.remove('is-loading');
        bindCartControls();
      })
      .catch(function () { body.classList.remove('is-loading'); });
  }

  function openCartDrawer() {
    var drawer = $('#CartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    d.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    var drawer = $('#CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    d.body.style.overflow = '';
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function (res) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCount(cart.item_count);
        if (window.themeSettings.cartType === 'drawer') {
          return rerenderDrawer().then(function () { openCartDrawer(); return res; });
        }
        window.location.href = '/cart';
        return res;
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      var subtotalEls = $$('[data-cart-subtotal]');
      subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
      if ($('[data-cart-body]')) return rerenderDrawer().then(function () { return cart; });
      window.location.reload();
      return cart;
    });
  }

  function bindCartControls() {
    $$('[data-qty-change]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        var input = $('[data-qty-input][data-line="' + line + '"]');
        var qty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyChange, 10));
        input.value = qty;
        changeLine(line, qty);
      });
    });
    $$('[data-qty-input]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      input.addEventListener('change', function () {
        changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    $$('[data-cart-remove]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () { changeLine(parseInt(btn.dataset.line, 10), 0); });
    });
    var note = $('[data-cart-note]');
    if (note && !note.dataset.bound) {
      note.dataset.bound = '1';
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }
  }

  function initCart() {
    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (window.themeSettings.cartType !== 'drawer') return;
        e.preventDefault();
        rerenderDrawer().then(openCartDrawer);
      });
    });
    $$('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
    bindCartControls();
  }

  /* ---------- Quick add ---------- */
  function initQuickAdd() {
    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var original = btn.textContent;
      btn.textContent = window.themeStrings.adding;
      btn.disabled = true;
      addToCart([{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }])
        .then(function () {
          btn.textContent = window.themeStrings.added;
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = window.themeStrings.cartError;
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
        });
    });
  }

  /* ---------- Quick view ---------- */
  function initQuickView() {
    var modal = $('#QuickviewModal');
    if (!modal) return;
    var content = $('#QuickviewContent');

    function close() { modal.hidden = true; d.body.style.overflow = ''; }
    $$('[data-quickview-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    d.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.dataset.productUrl.split('?')[0];
      fetch(url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '';
          var optionsHtml = p.options.map(function (opt, oi) {
            var values = opt.values.map(function (v) {
              return '<label class="variant-chip"><input type="radio" name="qv-option-' + oi + '" value="' + v.replace(/"/g, '&quot;') + '"' + (oi === 0 && v === opt.values[0] || v === opt.values[0] ? ' checked' : '') + '><span class="variant-chip__text">' + v + '</span></label>';
            }).join('');
            return '<fieldset class="variant-option"><legend class="variant-option__label">' + opt.name + '</legend><div class="variant-option__values">' + values + '</div></fieldset>';
          }).join('');
          content.innerHTML =
            '<div class="quickview-product">' +
              '<div class="quickview-product__media">' + img + '</div>' +
              '<div>' +
                '<h2 class="quickview-product__title">' + p.title + '</h2>' +
                '<div class="price" data-qv-price>' + formatMoney(p.price) + '</div>' +
                '<form data-qv-form>' + optionsHtml +
                  '<button type="submit" class="btn btn--full" data-qv-add>' + window.themeStrings.addToCart + '</button>' +
                '</form>' +
                '<a href="' + p.url + '" class="link-underline quickview-product__link">' + window.themeStrings.viewDetails + '</a>' +
              '</div>' +
            '</div>';

          var form = $('[data-qv-form]', content);
          function currentVariant() {
            var selected = p.options.map(function (_, oi) {
              var checked = form.querySelector('input[name="qv-option-' + oi + '"]:checked');
              return checked ? checked.value : null;
            });
            return p.variants.find(function (v) {
              return selected.every(function (s, i) { return v.options[i] === s; });
            });
          }
          function syncState() {
            var v = currentVariant();
            var addBtn = $('[data-qv-add]', content);
            var priceEl = $('[data-qv-price]', content);
            if (!v) { addBtn.disabled = true; addBtn.textContent = window.themeStrings.unavailable; return; }
            addBtn.disabled = !v.available;
            addBtn.textContent = v.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
            priceEl.innerHTML = v.compare_at_price > v.price
              ? '<span class="price__sale">' + formatMoney(v.price) + '</span> <s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>'
              : formatMoney(v.price);
          }
          form.addEventListener('change', syncState);
          form.addEventListener('submit', function (ev) {
            ev.preventDefault();
            var v = currentVariant();
            if (!v) return;
            var addBtn = $('[data-qv-add]', content);
            addBtn.textContent = window.themeStrings.adding;
            addToCart([{ id: v.id, quantity: 1 }]).then(close).catch(function () {
              addBtn.textContent = window.themeStrings.cartError;
            });
          });
          syncState();
          modal.hidden = false;
          d.body.style.overflow = 'hidden';
        });
    });
  }

  /* ---------- Product page ---------- */
  function initProductPage() {
    var wrapper = $('[data-product-wrapper]');
    if (!wrapper) return;

    var form = $('[data-product-form]') || $('form[action*="/cart/add"]', wrapper);
    var variantJsonEl = $('[data-variant-json]', wrapper);
    var picker = $('[data-variant-picker]', wrapper);
    var idInput = $('[data-variant-id-input]', wrapper);
    var variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];

    if (picker && variants.length) {
      picker.addEventListener('change', function () {
        var selected = $$('.variant-option', picker).map(function (fs) {
          var checked = fs.querySelector('input:checked');
          var label = fs.querySelector('[data-selected-value]');
          if (checked && label) label.textContent = checked.value;
          return checked ? checked.value : null;
        });
        var variant = variants.find(function (v) {
          return selected.every(function (s, i) { return v['option' + (i + 1)] === s; });
        });
        var addBtn = $('[data-add-to-cart]');
        var addText = $('[data-add-to-cart-text]');
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (addBtn) addBtn.disabled = !variant.available;
          if (addText) addText.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
          var priceWrap = $('[data-price-wrapper]');
          if (priceWrap) {
            var priceHtml;
            if (variant.compare_at_price > variant.price) {
              priceHtml = '<div class="price price--on-sale"><span class="price__sale">' + formatMoney(variant.price) + '</span> <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s></div>';
            } else {
              priceHtml = '<div class="price"><span class="price__label">' + window.themeStrings.regularPrice + '</span><span class="price__regular">' + formatMoney(variant.price) + '</span></div>';
            }
            priceWrap.innerHTML = priceHtml;
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        } else {
          if (addBtn) addBtn.disabled = true;
          if (addText) addText.textContent = window.themeStrings.unavailable;
        }
      });
    }

    var qtyInput = form ? $('input[name="quantity"]', form) : null;
    var minus = $('[data-qty-minus]', wrapper);
    var plus = $('[data-qty-plus]', wrapper);
    if (minus && qtyInput) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus && qtyInput) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    if (form && window.themeSettings.cartType === 'drawer') {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name === 'checkout') return;
        e.preventDefault();
        var addBtn = $('[data-add-to-cart]', form);
        var addText = $('[data-add-to-cart-text]', form);
        var prev = addText ? addText.textContent : '';
        if (addText) addText.textContent = window.themeStrings.adding;
        addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }])
          .then(function () {
            if (addText) { addText.textContent = window.themeStrings.added; setTimeout(function () { addText.textContent = prev; }, 1500); }
          })
          .catch(function () {
            if (addText) { addText.textContent = window.themeStrings.cartError; setTimeout(function () { addText.textContent = prev; }, 2000); }
          });
      });
    }

    // Size chart modal
    var sizeChartBtn = $('[data-size-chart-open]');
    var sizeChart = $('[data-size-chart]');
    if (sizeChartBtn && sizeChart) {
      sizeChartBtn.addEventListener('click', function () { sizeChart.hidden = false; d.body.style.overflow = 'hidden'; });
      $$('[data-size-chart-close]', sizeChart).forEach(function (b) {
        b.addEventListener('click', function () { sizeChart.hidden = true; d.body.style.overflow = ''; });
      });
    }

    // Sticky add-to-cart bar
    var sticky = $('[data-sticky-atc]');
    var buyArea = form;
    if (sticky && buyArea && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(buyArea);
      var stickyBtn = $('[data-sticky-add]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    // Complementary products
    var comp = $('[data-complementary]');
    if (comp) {
      fetch(comp.dataset.url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          if (!products.length) { comp.hidden = true; return; }
          $('[data-complementary-list]', comp).innerHTML = products.map(function (p) {
            return '<a class="complementary-item" href="' + p.url + '">' +
              (p.featured_image ? '<img src="' + p.featured_image + '&width=120" alt="" loading="lazy">' : '') +
              '<div><div class="complementary-item__title">' + p.title + '</div>' +
              '<div class="complementary-item__price">' + formatMoney(p.price) + '</div></div></a>';
          }).join('');
        })
        .catch(function () { comp.hidden = true; });
    }
  }

  /* ---------- Recently viewed ---------- */
  function initRecentlyViewed() {
    var section = $('[data-recently-viewed]');
    if (!section) return;
    var grid = $('[data-recently-viewed-grid]', section);
    var exclude = section.dataset.exclude;
    var handles;
    try { handles = JSON.parse(localStorage.getItem('theme:recently-viewed') || '[]'); } catch (e) { handles = []; }
    handles = handles.filter(function (h) { return h !== exclude; }).slice(0, 4);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      grid.innerHTML = products.map(function (p) {
        return '<div class="product-grid__item"><div class="product-card product-card--zoom">' +
          '<div class="product-card__media card-media--portrait"><a class="product-card__link" href="' + p.url + '">' +
          (p.featured_image ? '<img class="product-card__image product-card__image--primary" src="' + p.featured_image + '&width=540" alt="" loading="lazy">' : '') +
          '</a></div>' +
          '<div class="product-card__info"><a class="product-card__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="price"><span class="price__regular">' + formatMoney(p.price) + '</span></div></div>' +
          '</div></div>';
      }).join('');
      section.hidden = false;
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    var section = $('[data-recommendations]');
    if (!section || section.querySelector('.product-grid')) return;
    fetch(section.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) section.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Collection filters & sort ---------- */
  function initCollection() {
    var sidebar = $('[data-collection-sidebar]');
    var sortSelect = $('[data-sort-select]');

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    if (sidebar) {
      $$('[data-filters-open]').forEach(function (b) {
        b.addEventListener('click', function () { sidebar.classList.add('is-open'); d.body.style.overflow = 'hidden'; });
      });
      $$('[data-filters-close]').forEach(function (b) {
        b.addEventListener('click', function () { sidebar.classList.remove('is-open'); d.body.style.overflow = ''; });
      });
      var form = $('[data-filter-form]', sidebar);
      if (form) {
        var applyFilters = function () {
          var url = new URL(window.location.pathname, window.location.origin);
          var sort = new URL(window.location.href).searchParams.get('sort_by');
          if (sort) url.searchParams.set('sort_by', sort);
          $$('input[type="checkbox"]:checked', form).forEach(function (cb) {
            url.searchParams.append(cb.name, cb.value);
          });
          $$('input[type="number"]', form).forEach(function (num) {
            if (num.value) url.searchParams.set(num.name, num.value);
          });
          window.location.href = url.toString();
        };
        form.addEventListener('change', function (e) {
          if (e.target.type === 'checkbox') applyFilters();
        });
        $$('input[type="number"]', form).forEach(function (num) {
          num.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyFilters(); } });
          num.addEventListener('blur', function () { if (num.value) applyFilters(); });
        });
      }
    }
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.end).getTime();
      if (isNaN(end)) return;
      var daysEl = $('[data-cd-days]', el), hoursEl = $('[data-cd-hours]', el),
          minsEl = $('[data-cd-mins]', el), secsEl = $('[data-cd-secs]', el);
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var days = Math.floor(diff / 864e5);
        var hours = Math.floor(diff % 864e5 / 36e5);
        var mins = Math.floor(diff % 36e5 / 6e4);
        var secs = Math.floor(diff % 6e4 / 1e3);
        daysEl.textContent = days; hoursEl.textContent = ('0' + hours).slice(-2);
        minsEl.textContent = ('0' + mins).slice(-2); secsEl.textContent = ('0' + secs).slice(-2);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Popup ---------- */
  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;
    var key = 'theme:popup-dismissed';
    var frequencyDays = parseInt(popup.dataset.frequency, 10) || 7;
    try {
      var last = parseInt(localStorage.getItem(key) || '0', 10);
      if (Date.now() - last < frequencyDays * 864e5) return;
    } catch (e) {}
    function dismiss() {
      popup.hidden = true;
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }
    setTimeout(function () { popup.hidden = false; }, parseInt(popup.dataset.delay, 10) || 6000);
    $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', dismiss); });
  }

  /* ---------- Address forms ---------- */
  function initAddresses() {
    $$('[data-address-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = d.getElementById(btn.dataset.addressToggle);
        if (target) target.hidden = !target.hidden;
      });
    });
    $$('[data-confirm-message]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!confirm(btn.dataset.confirmMessage)) e.preventDefault();
      });
    });
    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      var country = $('[data-address-country]');
      var province = $('[data-address-province]');
      if (country && province) {
        new window.Shopify.CountryProvinceSelector(country.id || 'address_country', province.id || 'address_province', {});
      }
    }
  }

  /* ---------- Init ---------- */
  function init() {
    initReveal();
    initHeader();
    initAnnouncement();
    initLocalization();
    initMobileMenu();
    initSearch();
    initSlideshows();
    initCart();
    initQuickAdd();
    initQuickView();
    initProductPage();
    initRecentlyViewed();
    initRecommendations();
    initCollection();
    initCountdown();
    initPopup();
    initAddresses();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
